import { jsx as _jsx } from "react/jsx-runtime";
import { buildUrlPath } from 'lib/resolveUrl';
import { createRoot } from 'react-dom/client';
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router-dom';
import SubtitlesPage from 'pages/SubtitlesPage';
import { ConfigProvider, App } from 'antd';
import { theme } from 'ant-config';
import HomePage from 'pages/HomePage';
import StatsPage from 'pages/StatsPage';
import EventsPage from 'pages/EventsPage';
import EventPage from 'pages/EventPage';
import TranscriptionPage from 'pages/TranscriptionPage';
import SegmentReportPage from 'pages/SegmentReportPage';
import { I18nProvider } from 'components/I18nProvider';
import { initSyncedClock } from 'lib/server-clock';
import './global.css';
initSyncedClock();
const LiveApp = () => {
    return (_jsx(I18nProvider, { children: _jsx(ConfigProvider, { theme: theme, children: _jsx(App, { children: window.location.hash !== ''
                    ? _jsx(SubtitlesPage, { eventId: window.location.hash.slice(1) })
                    : _jsx(Outlet, {}) }) }) }));
};
const router = createBrowserRouter([
    {
        path: buildUrlPath('/'),
        element: _jsx(LiveApp, {}),
        children: [
            {
                path: '',
                element: _jsx(HomePage, {}),
            },
            {
                path: 'admin',
                element: _jsx(EventsPage, {}),
            },
            {
                path: 'admin/stats',
                element: _jsx(StatsPage, {}),
            },
            {
                path: 'admin/events/:eventId/segments/:segmentId/transcriptions/:lang',
                element: _jsx(TranscriptionPage, {}),
            },
            {
                path: 'admin/events/:eventId/segments/:segmentId/report',
                element: _jsx(SegmentReportPage, {}),
            },
            {
                path: 'admin/events/:eventId/:subpage?',
                element: _jsx(EventPage, {}),
            },
        ]
    },
]);
createRoot(document.querySelector('#app')).render(_jsx(RouterProvider, { router: router }));
